import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { KeyedRouteErrorBoundary } from '../RouteErrorBoundary';
import { useMobileAppShell } from '../../hooks/useIsMobile';
import { SiteAdSlot } from '../ads/SiteAdSlot';

export function PublicLayout() {
  const mobileAppShell = useMobileAppShell();

  if (mobileAppShell) {
    return (
      <div className="mobile-app-container mobile-page">
        <Header />
        <SiteAdSlot slotKey="header" shell="public" />
        <main className="mobile-content">
          <SiteAdSlot slotKey="midRoll" shell="public" />
          <KeyedRouteErrorBoundary>
            <Outlet />
          </KeyedRouteErrorBoundary>
        </main>
        <SiteAdSlot slotKey="footer" shell="public" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <SiteAdSlot slotKey="header" shell="public" />
      <main className="flex-1">
        <SiteAdSlot slotKey="midRoll" shell="public" />
        <KeyedRouteErrorBoundary>
          <Outlet />
        </KeyedRouteErrorBoundary>
      </main>
      <SiteAdSlot slotKey="footer" shell="public" />
      <Footer />
    </div>
  );
}
